// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner__HWX7y {
  height: 36px;
  grid-area: banner;
  background-color: #F6F6F6;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: Inter, Arial, Helvetica, sans-serif;
  font-size: 12px;
}

.link__BpjYh {
  margin-left: 17px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #0467D2;

  &:hover {
    color: #00389E;
  }
}

.divider__YnXfC {
  height: 16px;
  border-left: 1px solid #BCBCBC;
  margin: 8px;
}

.details__nCyel {
  font-weight: 500;
  color: #000;
}

/* Mobile styles (under 480px) */
@media only screen and (max-width: 480px) {
  .banner__HWX7y {
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProxyBanner/proxyBanner.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,cAAc;;EAEd;IACE,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".banner {\n  height: 36px;\n  grid-area: banner;\n  background-color: #F6F6F6;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-family: Inter, Arial, Helvetica, sans-serif;\n  font-size: 12px;\n}\n\n.link {\n  margin-left: 17px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n  color: #0467D2;\n\n  &:hover {\n    color: #00389E;\n  }\n}\n\n.divider {\n  height: 16px;\n  border-left: 1px solid #BCBCBC;\n  margin: 8px;\n}\n\n.details {\n  font-weight: 500;\n  color: #000;\n}\n\n/* Mobile styles (under 480px) */\n@media only screen and (max-width: 480px) {\n  .banner {\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `banner__HWX7y`,
	"link": `link__BpjYh`,
	"divider": `divider__YnXfC`,
	"details": `details__nCyel`
};
module.exports = ___CSS_LOADER_EXPORT___;
